import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { BackgroundMode } from '@ionic-native/background-mode';

import {SplashPage} from "../pages/splash/splash";
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = SplashPage;

  constructor(platform: Platform, statusBar: StatusBar, private backgroundMode: BackgroundMode) {
    platform.ready().then(() => {
      this.backgroundMode.enable();
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleLightContent();
      //splashScreen.hide();
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts